/**
 * PERSON CHANNEL THUNKS — read-only (clone di personSourceThunks).
 */

import { createAsyncThunk } from '@reduxjs/toolkit';
import type { Page, ServerListParams } from '@crm/shared';
import type { RootState } from '../../store/store';
import { requireGroupId, extractError } from '../../store/thunkHelpers';
import { personChannelApi } from './personChannelApi';
import type { PersonChannel } from './personChannelTypes';

export const fetchPersonChannels = createAsyncThunk<
  Page<PersonChannel>,
  ServerListParams | undefined,
  { state: RootState; rejectValue: string }
>('personChannels/fetchAll', async (params, { getState, rejectWithValue }) => {
  try {
    return await personChannelApi.getAll(requireGroupId(getState), params);
  } catch (err: unknown) {
    return rejectWithValue(extractError(err));
  }
});
